export const INSCRIPTION_RESET = "INSCRIPTION_RESET";
export const INSCRIPTION_SET_ERROR = "INSCRIPTION_SET_ERROR";
export const INSCRIPTION_SET_ITEMS = "INSCRIPTION_SET_ITEMS";
export const INSCRIPTION_TOGGLE_LOADING = "INSCRIPTION_TOGGLE_LOADING";
